var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_36734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.40273 8.98906H1.80273L9.00273 1.78906L16.2027 8.98906H14.6027",
    fill: "#475168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40273 8.98906H1.80273L9.00273 1.78906L16.2027 8.98906H14.6027",
    stroke: "#475168",
    strokeWidth: 0.604167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30078 9V14.3667C3.30078 14.7733 3.47236 15.1633 3.77778 15.4509C4.0832 15.7385 4.49743 15.9 4.92935 15.9H13.0722C13.5041 15.9 13.9184 15.7385 14.2238 15.4509C14.5292 15.1633 14.7008 14.7733 14.7008 14.3667V9",
    fill: "#475168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30078 9V14.3667C3.30078 14.7733 3.47236 15.1633 3.77778 15.4509C4.0832 15.7385 4.49743 15.9 4.92935 15.9H13.0722C13.5041 15.9 13.9184 15.7385 14.2238 15.4509C14.5292 15.1633 14.7008 14.7733 14.7008 14.3667V9",
    stroke: "#475168",
    strokeWidth: 0.604167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20117 16.4922V13.1172C7.20117 12.8188 7.3276 12.5327 7.55264 12.3217C7.77769 12.1107 8.08291 11.9922 8.40117 11.9922H9.60117C9.91943 11.9922 10.2247 12.1107 10.4497 12.3217C10.6747 12.5327 10.8012 12.8188 10.8012 13.1172V16.4922",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_36734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.8f1711625200d9386268c5db97f5e2e7.svg";
export { ForwardRef as ReactComponent };